<template>
  <div>
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <a-form-item :label-col="{ span: 3 }" label="计划" :wrapper-col="{ span: 21 }">
              <a-select v-model="plan" :disabled="disabledAll" @change="planChange" style="width: 280px">
                <a-select-option v-for="item in planList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ totalPremium }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div class="title_">
          <div class="cutleft_ order">主险</div>
        </div>
        <div class="flex_">
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="累计及每次事故赔偿限额">
              <a-input disabled style="width: 280px" :value="planList[planIdx].money1" placeholder="累计及每次事故赔偿限额" />
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="每次事故财产损失限额">
              <a-input disabled style="width: 280px" :value="planList[planIdx].money2" placeholder="每次事故财产损失限额" />
            </a-form-item>
          </div>
        </div>
        <div class="title_">
          <div class="cutleft_ order">加费承保</div>
        </div>
        <div class="flex_">
          <div class="form_item">
            <a-form-item :label-col="{ span: 10 }" label="美容美发服务责任">
              <a-select v-model="checked" :disabled="disabledAll" @change="checkedChange" style="width: 280px">
                <a-select-option :value="true">附加</a-select-option>
                <a-select-option :value="false">不附加</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="title_">
          <div class="cutleft_ order">免费扩展承保</div>
        </div>
        <div class="flex_ mianfei">
          <div class="form_item">
            <a-form-item :label-col="{ span: 17 }" label="客人财产责任（累计每次事故限额5万，每次事故财产损失限额1万）">
              <a-select disabled :value="1" style="width: 280px">
                <a-select-option :value="1">附加</a-select-option>
                <a-select-option :value="0">不附加</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 17 }" label="食品、饮料责任（累计每次事故限额50万，每次事故财产损失限额10万）">
              <a-select disabled :value="1" style="width: 280px">
                <a-select-option :value="1">附加</a-select-option>
                <a-select-option :value="0">不附加</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 17 }" label="急救费用（每次事故财产损失限额5000）">
              <a-select disabled :value="1" style="width: 280px">
                <a-select-option :value="1">附加</a-select-option>
                <a-select-option :value="0">不附加</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 17 }" label="社交和体育活动扩展条款（累计每次事故限额50万，每次事故财产损失限额10万）">
              <a-select disabled :value="1" style="width: 280px">
                <a-select-option :value="1">附加</a-select-option>
                <a-select-option :value="0">不附加</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="form_item">
            <a-form-item :label-col="{ span: 17 }" label="广告及装饰装置责任条款（累计每次事故限额50万，每次事故财产损失限额10万）">
              <a-select disabled :value="1" style="width: 280px">
                <a-select-option :value="1">附加</a-select-option>
                <a-select-option :value="0">不附加</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">去投保</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      form: {},
      plan: '',
      checked: false,
    };
  },
  computed: {
    //计划列表
    planList() {
      if (this.checked) {
        //C类
        return DATA.plansValues.slice(10);
      } else {
        return DATA.plansValues.slice(0, 10);
      }
    },
    //总保费
    totalPremium() {
      let hasOne = this.planList.find(item => item.value == this.plan);
      return hasOne ? hasOne.premium : 0;
    },
    planIdx() {
      let idx = 0;
      this.planList.forEach((item, i) => {
        if (item.value == this.plan) {
          idx = i;
        }
      });
      return idx;
    },
  },
  watch: {},
  props: ['disabledAll'],
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
    this.$nextTick(() => {
      let hasOne = this.planList.findIndex(item => item.value == planCode);
      if (hasOne == -1) {
        this.plan = '';
      }
    });
    this.userParams = {
      //从地址中获取
      userId: u,
      productCode: p,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    checkedChange() {
      if (this.checked) {
        //C类
        this.plan = this.plan.replace(/B/g, 'C');
      } else {
        this.plan = this.plan.replace(/C/g, 'B');
      }
      this.$nextTick(() => {
        this.$parent.$refs.policyInfo.totalPremiumChange(this.totalPremium);
      });
    },
    planChange() {
      this.$nextTick(() => {
        this.$parent.$refs.policyInfo.totalPremiumChange(this.totalPremium);
      });
    },
    // 去投保
    goplicy() {
      if (!this.plan) {
        this.$message.warning('请选择计划');
        return;
      }
      this.$store.commit('setAgreement', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  display: none;
}

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}

.form_item {
  margin-bottom: 0;
  .ant-form-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: '500000元起保';
  position: absolute;
  color: #999999;
  top: 10px;
  right: 30px;
  z-index: 2;
}
.tiaokuan_list {
  line-height: 24px;
}
.form_item .ant-form-item {
  margin-bottom: 5px;
}
</style>